import { useState } from "react";
import type { Episode } from "@/mocks/movies";

interface EpisodeListProps {
  episodes: Episode[];
}

export default function EpisodeList({ episodes }: EpisodeListProps) {
  const [active, setActive] = useState(episodes[0]?.episode ?? 1);
  const current = episodes.find((item) => item.episode === active) ?? episodes[0];

  if (episodes.length === 0) return null;

  return (
    <div>
      <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar md:flex-wrap md:overflow-visible">
        {episodes.map((item) => (
          <button
            key={item.episode}
            type="button"
            onClick={() => setActive(item.episode)}
            className={`shrink-0 whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors ${
              active === item.episode
                ? "bg-primary-500 font-medium text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            第 {item.episode} 集
          </button>
        ))}
      </div>

      {current && (
        <div className="mt-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded-full bg-accent-100 px-3 py-0.5 text-xs font-medium text-accent-800">
              第 {current.episode} 集
            </span>
            <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
              {current.title}
            </h3>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{current.desc}</p>
          <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-information-line"></i>
            本页仅为剧集信息展示，不提供真实播放与下载功能
          </p>
        </div>
      )}
    </div>
  );
}